<div fxLayout="column" fxLayoutAlign="space-between stretch" fxFlexFill>
  <div fxFlex="0 0 auto" fxLayout="row" fxLayoutAlign="space-between">
    <!-- <unesp-core-header fullTitle="{{fullTitle}}" shortTitle="{{shortTitle}}" logoCustom="{{logoCustom}}" fxFlexFill></unesp-core-header> -->
    <unicamp-core-header fullTitle="{{fullTitle}}" shortTitle="{{shortTitle}}" logoCustom="{{logoCustom}}" fxFlexFill></unicamp-core-header>
  </div>
  <div fxFlex="1 1 auto">
    <unesp-core-sidenav fxFlex="1 1 auto" spinnerCustom="{{spinnerCustom}}">
      <div class="ngcontent-content" fxFlexFill>
        <ng-content select=".ngcontent-router"></ng-content>
      </div>       
    </unesp-core-sidenav>
  </div>
  <div fxFlex="0 0 auto" fxLayout="row" id="unesp-core-footer">
    <unesp-core-footer fxFlexFill>
      <div class="ngcontent-select-footer">
        {{footerText}}
      </div>
    </unesp-core-footer>
  </div>
</div>